import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

export default function GraficoQtdComDiaEquipamento({ dados }) {
  // dados esperados: [{ equipamento: 'Trator A', qtd: 5 }, { equipamento: 'Caminhão B', qtd: 3 }]
  // console.log('dados em GraficoQtdComDiaEquipamento: ', dados);

  const labels = dados ? dados.map(d => d.Eqp) : [];
  const valores = dados ? dados.map(d => d.Comp) : [];

  const data = {
    labels,
    datasets: [
      {
        label: 'Qtd. Compartimentos',
        data: valores,
        backgroundColor: 'rgba(27, 85, 243, 0.8)', // text-blue-900 equivalente
        borderColor: 'rgba(27, 85, 243, 0.8)',
        borderWidth: 1,
      },
    ],
  };
 
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: 'Qtd. Compartimentos por Equipamento',
        font: { size: 16 },
        padding: { bottom: 20 }
      },
      datalabels: {
        color: '#fff',
        font: { weight: 'bold' },
        anchor: 'center',
        align: 'center',
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { stepSize: 1 }
      }
    }
  };

  return (
    <div className="bg-white p-4 shadow-sm rounded-lg h-80 flex flex-col items-center justify-center">
      {dados && dados.length > 0 ? (
        <Bar data={data} options={options} />
      ) : (
        <p className="text-gray-400">Sem dados para exibir</p>
      )}
    </div>
  );
}
